import { ref, shallowRef } from 'vue';

// Global state
const isVisible = ref(false);
const activeComponent = shallowRef(null)
const activeProps = ref({})
const storedProps = ref({})
const callback = ref(null);
const dismissible = ref(true);

const popupStack = ref([]);
const storedCallbackResult = ref(null);

const tempCallback = ref(null);
const tempResult = ref(null);

export function usePopupController() {
    const showPopup = (component, props = {}, onResult = null, revertPrevious = false, options = {}) => {
        if (revertPrevious) {
            popupStack.value.push({
                activeComponent: shallowRef(activeComponent.value),
                activeProps: { ...activeProps.value },
                storedProps: { ...storedProps.value },
                callback: callback.value,
                storedCallbackResult: storedCallbackResult.value,
            });
    
            // Reset previous callback result
            storedCallbackResult.value = null;
        }
        
        activeComponent.value = component
        activeProps.value = props
        isVisible.value = true
        callback.value = onResult;
        dismissible.value = options.dismissible !== false;
    }

    const handlePopupResult = (result) => {
        if (callback.value) {
            if (popupStack.value.length > 0) {
                tempCallback.value = callback.value;
                tempResult.value = result;
            } else {
                callback.value(result); // Call the callback with the result
                callback.value = null; // Clear the callback
            }
        }
    }

    const storeProps = (props) => {
        storedProps.value = props
    }

    const hidePopup = () => {
        if (popupStack.value.length > 0) {
            const previousPopup = popupStack.value.pop();
    
            // Restore the previous popup state
            activeComponent.value = previousPopup.activeComponent;
            Object.assign(activeProps.value, previousPopup.activeProps);
            Object.assign(storedProps.value, previousPopup.storedProps);
            callback.value = previousPopup.callback;
    
            // Invoke the callback with the stored result
            if (tempCallback.value && tempResult.value !== null) {
                try {
                    tempCallback.value(tempResult.value);
                    tempCallback.value = null;
                    tempResult.value = null;
                } catch (error) {
                    console.error("Error invoking callback:", error);
                }
            }
        } else {
            // No previous popup, simply hide the current one
            activeComponent.value = null;
            activeProps.value = {};
            storedProps.value = {};
            callback.value = null;
            storedCallbackResult.value = null;
            isVisible.value = false;
            dismissible.value = true;
        }
    }

    return {
        isVisible,
        activeComponent,
        activeProps,
        storedProps,
        dismissible,
        handlePopupResult,
        showPopup,
        hidePopup,
        storeProps,
    };
}